import { useModalContentToggler } from '@components'

import { Button, ButtonsGroup, Flex, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useMissingCompanyDetailsForm } from '../../contexts/missingCompanyDetailsFormContext'
import { MissingComplianceDetailsModalStateId } from '../../enums/missingComplianceDetailsModalStateId'
import { useMissingComplianceDetailsModalStateId } from '../../hooks/useMissingComplianceDetailsModalStateId'

export const MissingCompanyDetailsModalFooter = (): ReactElement => {
  const { t } = useTranslation()
  const { isLoading, isSubmitting, onConfirm, submitForm, validate } = useMissingCompanyDetailsForm()
  const { setActiveState } = useModalContentToggler()
  const { close: closeMissingComplianceDetailsModal } = useModal(ModalId.InvoiceEditorMissingComplianceDetailsModal)
  const { getNextStateId } = useMissingComplianceDetailsModalStateId()

  const isFooterActionButtonDisabled = isLoading || isSubmitting

  const handleCancelButtonClick = useCallback(() => {
    closeMissingComplianceDetailsModal()
  }, [closeMissingComplianceDetailsModal])

  const onFormSubmit = useCallback(() => {
    const nextStateId = getNextStateId(MissingComplianceDetailsModalStateId.MissingCompanyDetails)
    if (nextStateId) {
      setActiveState(nextStateId)
    } else {
      onConfirm?.()
      closeMissingComplianceDetailsModal()
    }
  }, [closeMissingComplianceDetailsModal, getNextStateId, onConfirm, setActiveState])

  const handleSaveAndContinueButtonClick = useCallback(async () => {
    const isFormValid = await validate()

    if (isFormValid) {
      submitForm(onFormSubmit)
    }
  }, [onFormSubmit, submitForm, validate])

  return (
    <Flex justifyContent="flex-end" alignItems="center" flexGrow={1}>
      <ButtonsGroup>
        <Button disabled={isFooterActionButtonDisabled} onClick={handleCancelButtonClick} variant="text">
          {t('external_invoices.send_as_e_invoice.modal.buttons.cancel')}
        </Button>
        <Button
          disabled={isFooterActionButtonDisabled}
          loading={isSubmitting}
          onClick={handleSaveAndContinueButtonClick}
        >
          {t('external_invoices.send_as_e_invoice.modal.buttons.save_and_continue')}
        </Button>
      </ButtonsGroup>
    </Flex>
  )
}
